/**
 * Compact "real couples" social proof for marketing homepage.
 * Dark background, gold accents — matches new dark landing theme.
 */

const GOLD = "#D4AF37";
const GOLD_SOFT = "#F4E5BC";
const INK = "#0A0908";
const INK_2 = "#15120E";
const LINE = "#2a2620";

const QUOTES = [
  { name: "Priya S.", loc: "Mumbai", text: "Our guests loved it! So elegant and easy to share." },
  { name: "Rahul & Neha", loc: "Delhi", text: "Best ₹999 we spent on our wedding." },
  { name: "Anjali K.", loc: "London", text: "Perfect for sharing with our family in India." },
];

export default function HomepageSocialProof() {
  return (
    <section
      className="py-20 md:py-24 px-6 md:px-10 border-y"
      style={{ background: INK_2, borderColor: LINE, color: GOLD_SOFT }}
      data-testid="homepage-social-proof"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-[10px] uppercase tracking-[0.5em] mb-3" style={{ color: GOLD }}>Loved by real couples</div>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-tight">
            <em style={{ color: GOLD }}>500+ couples</em> have chosen Weddinsite.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {QUOTES.map((q, i) => (
            <figure
              key={i}
              className="p-7 md:p-8 transition-transform hover:-translate-y-1"
              style={{ background: INK, border: `1px solid ${LINE}` }}
              data-testid={`testimonial-card-${i}`}
            >
              <div className="text-2xl mb-3" style={{ color: GOLD }}>★ ★ ★ ★ ★</div>
              <blockquote className="font-serif-display text-xl md:text-2xl italic font-light leading-snug" style={{ color: GOLD_SOFT }}>
                "{q.text}"
              </blockquote>
              <figcaption className="mt-6 text-[11px] uppercase tracking-[0.3em]" style={{ color: "#a8a098" }}>
                — {q.name} <span style={{ color: GOLD }}>·</span> {q.loc}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
